type EnvMap = Record<string, string | undefined>;

export const getViteEnvFrom = (getEnv: () => unknown): EnvMap => {
  try {
    const env = getEnv();
    return (env ?? {}) as EnvMap;
  } catch {
    return {};
  }
};

export const getViteEnv = (): EnvMap => {
  return getViteEnvFrom(() => import.meta.env);
};
